import React from 'react';

function Skills() {
    return (
           
        <>
        <h1 id="center">Skills</h1>
        <div className="skills" id="skills">

        <div className="box"> 
         <h1>📙</h1>
         <p>Html</p>
         </div>
         <div className="box"> 
         <h1>📘</h1>
         <p>CSS</p>
         </div>
         <div className="box"> 
         <h1>📕</h1>
         <p>JS</p>
         </div>

         <div className="box"> 
         <h1>⚛️</h1>
         <p>React</p>
         </div>
         <div className="box"> 
         <h1>🔥</h1>
         <p>Firebase</p>
         </div>
         <div className="box"> 
         <h1>🎨</h1>
         <p>Figma</p>
         </div>

  
        
        </div>

    {/* <table>
        <tr>
            <td>📙Html</td>
            <td>⚛️React</td>
        </tr>
        <tr>
            <td>📗Css</td>
            <td>🔥Firebase</td>
        </tr>
        <tr>
            <td>📕Js</td>
            <td>🎨Figma</td>
        </tr>
        </table> */}


  
        
   
    </>
    );
};

export default Skills;
